// extracted by mini-css-extract-plugin
export default {"switcher":"AppSwitcher_switcher__OUVjG","switcherDropdown":"AppSwitcher_switcherDropdown__aERb4","appName":"AppSwitcher_appName__Trect","appIcon":"AppSwitcher_appIcon__w2YC5"};